import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Button, DatePicker, Checkbox, Space, Table, Modal, Select, Tooltip } from "antd";
import "./packing_list.css";
import { withPackingListLogic, DataType, PackingListItem } from "../../components/hoc_packing_list";
import { FormInstance } from "antd";
import BrowserPackingListSo from "./browser_packing_list_so";
import AddItemPacking from "./add_item_available_packing";
import EditItemPacking from "./edit_item_packing";
import { IoPrintSharp } from "react-icons/io5";
import { FiRefreshCw } from "react-icons/fi";

interface PackingListProps {
    transformStyle: React.CSSProperties;
    columns: any;
    rowSelection: any;
    form: FormInstance;
    debouncedAutoSave: (changedValues: any, allValues: any, itemsOverride?: PackingListItem[]) => void;
    isBrowserSoModalVisible: boolean;
    handleBrowserSoClick: () => void;
    handleSelectSalesOrder: (salesOrderNo: string) => void;
    handleCloseBrowserSoModal: () => void;
    expeditionNameOptions: { value: string; label: string; }[];
    isAddItemModalVisible: boolean;
    handleAddItemClick: () => void;
    handleCloseAddItemModal: () => void;
    currentSalesOrderNo: string | undefined;
    packingListItems: PackingListItem[];
    handleSelectPickingListItems: (pickingListNos: string[]) => void;
    handleDeleteSelectedItems: () => void;
    handleRefreshClick: () => void;
    isEditItemModalVisible: boolean;
    editingItemData: PackingListItem | null;
    handleEditItemClick: (item: PackingListItem) => void;
    handleCloseEditItemModal: () => void;
    handleSaveEditedItem: (updatedItem: PackingListItem) => void;
    handleSubmitPackingList: () => void;
    handleNewClick: () => void;
    handleVoidPackingList: () => void;
    isReadyStatus: boolean;
    handlePrintClick: () => void;
    isPrinting: boolean;
    importedPickingListNos: Set<string>;
    autosaveStatus: 'idle' | 'processing' | 'error' | 'stopped';
    isSubmitting: boolean;
    isprogress: boolean;
    isReportModalOpen: boolean;
    handleReportModalCancel: () => void;
}

const PackingList: React.FC<PackingListProps> = ({
    transformStyle,
    columns,
    rowSelection,
    form,
    debouncedAutoSave,
    isBrowserSoModalVisible,
    handleBrowserSoClick,
    handleSelectSalesOrder,
    handleCloseBrowserSoModal,
    expeditionNameOptions,
    isAddItemModalVisible,
    handleAddItemClick,
    handleCloseAddItemModal,
    currentSalesOrderNo,
    packingListItems,
    handleSelectPickingListItems,
    handleDeleteSelectedItems,
    handleRefreshClick,
    isEditItemModalVisible,
    editingItemData,
    handleEditItemClick,
    handleCloseEditItemModal,
    handleSaveEditedItem,
    handleSubmitPackingList,
    handleNewClick,
    handleVoidPackingList,
    isReadyStatus,
    handlePrintClick,
    isPrinting,
    importedPickingListNos,
    autosaveStatus,
    isSubmitting,
    isprogress,
    isReportModalOpen,
    handleReportModalCancel
}) => {
    const deliveryMethod = Form.useWatch('delivery_method', form);
    const currentStatus = Form.useWatch('status', form);
    const isDraft = currentStatus === "Draft" || currentStatus === "1";
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Refreshbtn = FiRefreshCw as React.ComponentType<any>;

    return (

        <div id="iau9" style={transformStyle}>
            <div className="gjs-grid-row" id="ixb4h">
                <div className="gjs-grid-column" id="icdpi">
                    <Breadcrumb
                        items={[
                            {
                                href: "",
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/browser_packing_list",
                                title: (
                                    <>
                                        <span>Data Packing List</span>
                                    </>
                                ),
                            },
                            {
                                title: "Packing List",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="uuuuriasj">
                <div className="gjs-grid-column" id="iiioedjsk">
                    <Button className="pr-button" onClick={handleNewClick}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z"
                                clipRule="evenodd"
                            />
                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                        </svg>
                        New
                    </Button>
                    <Button
                        className="pr-button"
                        onClick={handleSubmitPackingList}
                        disabled={!isDraft || isSubmitting}
                        loading={isSubmitting}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Submit
                    </Button>
                    <Button
                        className="pr-button"
                        onClick={handleVoidPackingList}
                        disabled={!isDraft}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Void
                    </Button>
                    <Button className="pr-button" onClick={handlePrintClick} loading={isPrinting} disabled={isDraft || isprogress}>
                        <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>

            <div className="gjs-grid-row" id="ihzpf">
                <div className="gjs-grid-column" id="iod9s">
                    <Form
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        form={form}
                        onValuesChange={isReadyStatus ? undefined : debouncedAutoSave}
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Packing List No"
                            name="packing_list_no"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Packing List Date"
                            name="packing_list_date"
                            style={{
                                marginBottom: "5px", width: "60%",
                            }}
                        >
                            <Input readOnly style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item
                            label="Sales Order No"
                            name="sales_order_no"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Input
                                    placeholder=""
                                    style={{
                                        width: "90%",
                                    }}
                                    value={form.getFieldValue('sales_order_no') || ''}
                                    disabled={isReadyStatus}
                                />
                                <Button
                                    type="primary"
                                    id="browser_so"
                                    onClick={handleBrowserSoClick}
                                    icon={
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                            style={{
                                                width: "40px",
                                                height: "20px",
                                            }}
                                        >
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path
                                                fillRule="evenodd"
                                                d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                clipRule="evenodd"
                                            />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>
                                    }
                                    disabled={isReadyStatus || !!currentSalesOrderNo}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Delivery Method"
                            name="delivery_method"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={[
                                    { value: "", label: "--  Empty --" },
                                    { value: "1", label: "Delivery" },
                                    { value: "2", label: "Self Pickup" },
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                disabled={isReadyStatus}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Deliver To"
                            name="deliver_to"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly disabled={isReadyStatus} />
                        </Form.Item>
                        <Form.Item
                            label="customer_code"
                            name="cs_code"
                            style={{
                                marginBottom: "5px",
                                display: 'none',
                            }}
                        >
                            <Input placeholder="" readOnly disabled={isReadyStatus} />
                        </Form.Item>
                        <Form.Item
                            label="Deliver Via"
                            name="deliver_via"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly disabled={isReadyStatus} />
                        </Form.Item>
                        <Form.Item name="deliver_via_code" hidden>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="Expedition Name"
                            name="expediton_name"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={expeditionNameOptions}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                disabled={!deliveryMethod || isReadyStatus}

                            />
                        </Form.Item>
                        <Form.Item
                            label="Delivery Date"
                            name="date"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <DatePicker
                                format="DD/MM/YYYY"
                                placeholder="Select date"
                                style={{ width: "50%", fontSize: "14px" }}
                                popupStyle={{ fontSize: "12px" }}
                                disabled={isReadyStatus}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Remark"
                            name="remark"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input.TextArea rows={4} placeholder="Enter your remarks here..." disabled={isReadyStatus} />
                        </Form.Item>
                    </Form>

                </div>
                <div className="gjs-grid-column" id="il895">
                    <Form
                        layout="horizontal"
                        style={{ maxWidth: 500, paddingRight: '30px' }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        form={form}
                        onValuesChange={isReadyStatus ? undefined : debouncedAutoSave}
                    >
                        <Form.Item
                            label="Created By"
                            name="created_user"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled={isReadyStatus} readOnly/>
                        </Form.Item>
                        <Form.Item
                            label="Same as ID Address"
                            name="same_as_id"
                            style={{
                                marginBottom: "5px",
                            }}
                            valuePropName="checked"
                        >
                            <div
                                style={{
                                    gap: "0x",
                                    marginTop: "3px",
                                }}
                            >
                                <Checkbox disabled={isReadyStatus}>Yes</Checkbox>
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Delivery Address"
                            name="delivery_address"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Input.TextArea rows={4} placeholder="Enter your Delivery Address here..." disabled={isReadyStatus} />
                        </Form.Item>
                        <Form.Item
                            label="Contact Phone No"
                            name="contact_phone"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Input placeholder="" disabled={isReadyStatus} />
                        </Form.Item>
                        <Form.Item
                            label="ETA (in days)"
                            name="eta"
                            style={{
                                marginBottom: "5px",
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Input placeholder="" disabled={isReadyStatus} />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" disabled={isReadyStatus} readOnly />
                        </Form.Item>
                    </Form>
                </div>
            </div>

            { }
            <div className="gjs-grid-row" id="ip5tv">
                <div className="gjs-grid-column" id="iu42u">
                    <Table<DataType>
                        rowSelection={isReadyStatus ? undefined : rowSelection}
                        columns={columns}
                        style={{ paddingRight: '30px' }}
                        dataSource={packingListItems}
                        scroll={{ x: 900 }}
                        className="table-gr"
                        onRow={(record) => {
                            return {
                                onDoubleClick: isReadyStatus ? undefined : () => {
                                    handleEditItemClick(record);
                                },
                            };
                        }}
                    />
                    <div style={{ marginTop: "20px", textAlign: "left" }}>
                        <Space>
                            <Button
                                type="primary"
                                style={{
                                    height: "40px",
                                    width: "180px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }
                                onClick={handleAddItemClick}
                                disabled={isReadyStatus}
                            >
                                Add Available Item
                            </Button>
                            <Button
                                type="primary"
                                style={{
                                    height: "40px",
                                    width: "105px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }
                                disabled={isReadyStatus}
                            >
                                Add Line
                            </Button>
                            <Button
                                type="primary"
                                style={{
                                    height: "40px",
                                    width: "90px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                                    </svg>
                                }
                                onClick={handleDeleteSelectedItems}
                                disabled={isReadyStatus}
                            >
                                Delete
                            </Button>
                            <Button
                                type="primary"
                                style={{
                                    height: "40px",
                                    width: "90px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={<Refreshbtn size={22} />}
                                onClick={handleRefreshClick}
                                disabled={isReadyStatus || isprogress}
                            >
                                Refresh
                            </Button>
                        </Space>
                    </div>
                </div>
            </div>
            <Modal
                title="Browser Sales Order"
                open={isBrowserSoModalVisible}
                onCancel={handleCloseBrowserSoModal}
                footer={null}
                width="100%"
                style={{ maxWidth: 1100, minWidth: 'min(100%, 800px)' }}
            >
                <BrowserPackingListSo
                    onSelectSalesOrder={handleSelectSalesOrder}
                    onClose={handleCloseBrowserSoModal}
                />
            </Modal>
            <Modal
                title="Add Available Item"
                open={isAddItemModalVisible}
                onCancel={handleCloseAddItemModal}
                footer={null}
                width={670}
            >
                <AddItemPacking salesOrderNo={form.getFieldValue('sales_order_no')}
                    onSelectPickingListItems={handleSelectPickingListItems}
                    onClose={handleCloseAddItemModal}
                    importedPickingListNos={importedPickingListNos}
                />
            </Modal>
            <Modal
                title="Edit Packing List Item"
                open={isEditItemModalVisible}
                onCancel={handleCloseEditItemModal}
                footer={null}
                width={380}
            >
                {editingItemData && (
                    <EditItemPacking
                        initialData={editingItemData}
                        onClose={handleCloseEditItemModal}
                        onSave={handleSaveEditedItem}
                    />
                )}
            </Modal>
            <Modal
                title="Print Preview - Packing List"
                open={isReportModalOpen}
                onCancel={handleReportModalCancel}
                footer={null}
                width={1100}
                destroyOnClose
            >
                <div id="sti-viewer-container" style={{ width: '100%', minHeight: '75vh' }} />
            </Modal>
        </div>
    );
};

export default withPackingListLogic(PackingList);